import React, { createContext, useContext, useEffect, useState } from 'react';
import { User } from '../../domain/entities/User';
import { incrementStat } from '../../infrastructure/firebase/StatsService';

interface AuthContextValue {
  user: User | null;
  loading: boolean;
  signIn: (name: string) => void;
  signOut: () => void;
}

const AuthContext = createContext<AuthContextValue>({} as AuthContextValue);

function getOrCreateUserId(): string {
  let id = localStorage.getItem('pp_userId');
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('pp_userId', id);
  }
  return id;
}

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const name = localStorage.getItem('pp_userName');
    if (name) {
      setUser({ id: getOrCreateUserId(), name, email: '', isAdmin: false });
    }
    setLoading(false);
  }, []);

  const signIn = (name: string) => {
    const trimmed = name.trim();
    if (!trimmed) return;
    localStorage.setItem('pp_userName', trimmed);
    setUser({ id: getOrCreateUserId(), name: trimmed, email: '', isAdmin: false });
    incrementStat('totalUsers');
  };

  const signOut = () => {
    localStorage.removeItem('pp_userName');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
